export default "__VITE_ASSET__CuXUo4nK__"